import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';

export default function TopicSection() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {topics.map((topic) => (
        <Link
          key={topic.id}
          to="/category/news"
          className="group relative rounded-lg overflow-hidden h-56 md:h-64 cursor-pointer"
        >
          <img
            src={topic.cover}
            alt={topic.title}
            title={`${topic.title} - 91吃瓜专题`}
            className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/45 to-transparent" />
          <div className="relative h-full flex flex-col justify-end p-5">
            <span className="inline-flex w-fit items-center gap-1 px-2.5 py-1 rounded text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
              <i className="ri-bookmark-3-line" />
              专题 · {topic.count} 篇
            </span>
            <h3 className="mt-3 font-heading font-black text-xl text-background-50">
              {topic.title}
            </h3>
            <p className="mt-2 text-sm text-background-200/85 line-clamp-2">{topic.subtitle}</p>
            <div className="mt-3 flex items-center gap-2 flex-wrap">
              {topic.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2 py-0.5 rounded text-[11px] text-background-100 bg-background-50/15"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}